import { List } from '@mui/material';

import { INavItem } from '../model/types';
import { NavItem } from './NavItem';

interface INavItemsProps {
  items: INavItem[];
  isExpanded: boolean;
  /**
   * Пункт-действие (не роут) последним элементом списка. Именно внутри List,
   * а не рядом с ним: снаружи он получает лишний отступ родительского Stack
   * и визуально отваливается от остальных пунктов.
   */
  actionSlot?: React.ReactNode;
}

/**
 * Компонент с рендером всех элементов сайдбара
 * @param root0 - пропсы
 * @param root0.items - элементы сайдбара
 * @param root0.isExpanded - является ли сайдбар расширенным
 * @param root0.actionSlot - пункт-действие в конце списка
 */
export const NavItems = ({ items, isExpanded, actionSlot }: INavItemsProps) => {
  return (
    <List
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: isExpanded ? 'flex-start' : 'center',
        overflow: 'hidden'
      }}
    >
      {items.map(item => (
        <NavItem {...item} key={item.path} isExpanded={isExpanded} />
      ))}
      {actionSlot}
    </List>
  );
};
